import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M21.2765 12.2437C20.8685 10.3567 19.9705 9.07575 18.6055 8.43675C18.2865 8.28675 17.9425 8.18775 17.5845 8.11475C18.5835 6.84475 19.0215 5.22775 18.7915 3.57875L18.6875 2.83075L17.9395 2.72675C16.0495 2.46675 14.1995 3.07675 12.8675 4.40875C12.5055 4.77075 12.2025 5.17275 11.9505 5.60075C10.9905 3.78975 9.69952 2.73775 9.61352 2.66875L8.36252 4.22975C8.38652 4.24875 10.5125 6.01175 10.9175 8.76675C8.69352 7.86875 6.83352 7.75475 5.37552 8.43875C4.01052 9.07775 3.11152 10.3587 2.70452 12.2457C2.19452 14.6047 2.72852 16.9817 4.16952 18.7667C5.85352 20.8527 8.63052 22.0007 11.9915 22.0007C15.3525 22.0007 18.1295 20.8527 19.8125 18.7667C21.2525 16.9817 21.7865 14.6047 21.2765 12.2457V12.2437ZM14.2825 5.82175C14.9745 5.12975 15.8785 4.73075 16.8445 4.67375C16.7875 5.63975 16.3885 6.54475 15.6975 7.23575C15.0065 7.92675 14.1015 8.32675 13.1355 8.38275C13.1925 7.41675 13.5915 6.51275 14.2835 5.82075L14.2825 5.82175ZM18.2565 17.5097C16.9605 19.1147 14.7355 19.9997 11.9905 19.9997C9.24552 19.9997 7.02252 19.1147 5.72652 17.5097C4.65152 16.1787 4.27252 14.4577 4.66052 12.6657C4.93252 11.4037 5.44452 10.6137 6.22452 10.2477C6.57652 10.0837 6.99552 10.0017 7.47352 10.0017C8.56252 10.0017 9.95252 10.4257 11.5285 11.2487L11.9915 11.4917L12.4545 11.2487C14.7205 10.0627 16.6045 9.70875 17.7565 10.2477C18.5365 10.6127 19.0485 11.4037 19.3205 12.6657C19.7075 14.4577 19.3305 16.1777 18.2565 17.5097Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconApple = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconApple.displayName = "IconApple";

export { IconApple };
